<template>
  <div>
    <div ref="stackedBarActions"></div>
  </div>
</template>

<script>
import { makeChartOptions, makeChartObj, updateChartObj } from "@/utils/charts"

export default {
  name: "BarStackedActions",
  props: {
    actions: {
      type: Array
    },
    inspection: {
      type: String
    },
    nonConformityId: {
      type: Number
    }
  },
  data() {
    return {
      categories: [],
      chart: null,
      chartOptions: {},
      labels: [],
      series: []
    }
  },
  computed: {
    isThemeDark() {
      return this.$store.state.app.isThemeDark
    }
  },
  methods: {
    getSeries() {
      this.actions.forEach(element => {
        if (element.name == this.inspection) {
          element.non_conformity.forEach(nc => {
            if (nc.id == this.nonConformityId) {
              this.categories = []

              let corrective = []
              nc.corrective.forEach(c => {
                corrective.push(c.counts)
                this.categories.push(c.user_id__username)
              })

              let preventive = Array(corrective.length).fill(0)
              nc.preventive.forEach(p => {
                if (!this.categories.includes(p.user_id__username)) {
                  preventive.push(p.counts)
                  corrective.push(0)
                  this.categories.push(p.user_id__username)
                } else {
                  let index = this.categories.indexOf(p.user_id__username)
                  preventive.splice(index, 1, p.counts)
                }
              })

              this.series = [
                { name: "Corrective", data: corrective },
                { name: "Preventive", data: preventive }
              ]
            }
          })
        }
      })
    },
    getChartOptions() {
      return makeChartOptions({
        chart: {
          height: 400,
          type: "bar",
          stacked: true,
          toolbar: { show: true }
        },
        isThemeDark: this.isThemeDark,
        titleText: "Action types according to users",
        series: this.series,
        xaxis: { categories: this.categories }
      })
    },
    makeChart() {
      this.getSeries()
      const options = this.getChartOptions()
      this.chart = makeChartObj(this.$refs.stackedBarActions, options)
    },
    updateChart() {
      this.getSeries()
      const options = this.getChartOptions()
      updateChartObj(this.chart, options)
    }
  },
  mounted() {
    this.makeChart()
  },
  watch: {
    inspection: {
      handler(newValue) {
        this.updateChart()
      }
    },
    isThemeDark: {
      handler() {
        this.updateChart()
      }
    },
    nonConformityId: {
      handler(newValue) {
        this.updateChart()
      }
    }
  }
}
</script>
